import { Alert, AlertProps, Snackbar } from '@mui/material';
import RejectIcon from 'pages/BusinessManagement/components/RejectIcon';
import { NotificationType } from 'providers/NotificationProvider';

type NotificationPositionType = {
  horizontal: 'center' | 'left' | 'right';
  vertical: 'bottom' | 'top';
};
const NotificationPosition: {
  [key: string]: NotificationPositionType;
} = {
  topRight: { horizontal: 'right', vertical: 'top' },
  topLeft: { horizontal: 'left', vertical: 'top' },
};

interface NotificationProps extends AlertProps {
  open: boolean;
  message: string | React.ReactNode;
  position?: keyof typeof NotificationPosition;
  onClose: any;
  type: NotificationType;
}
const Notification: React.FC<NotificationProps> = ({
  open,
  message,
  position = 'topRight',
  onClose,
  type,
  ...props
}: NotificationProps) => {
  const classNameByType = (type: NotificationType) => {
    switch (type) {
      case 'success':
        return 'border border-success-tertiary text-success-on-secondary bg-success-tertiary';
      case 'error':
        return 'border border-danger-tertiary text-danger-on-secondary bg-danger-tertiary';
      case 'info':
        return 'border border-base-secondary text-default bg-base';
      default:
        return 'border border-danger-tertiary text-danger-on-secondary bg-danger-tertiary';
    }
  };
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      anchorOrigin={NotificationPosition[position]}
    >
      <Alert
        onClose={onClose}
        severity={type}
        iconMapping={{
          error: <RejectIcon width={20} height={20} />,
        }}
        variant="filled"
        sx={{ width: '300px' }}
        className={classNameByType(type)}
        {...props}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Notification;
